/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_DescriptionInputs */

const en_admin_roles_description = /** @type {(inputs: Admin_Roles_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage system roles and permissions`)
};

/**
* | output |
* | --- |
* | "Manage system roles and permissions" |
*
* @param {Admin_Roles_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_description = /** @type {((inputs?: Admin_Roles_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_description(inputs)
});
export { admin_roles_description as "admin.roles.description" }